import { Directive, HostBinding, Input } from '@angular/core';

import { ValidationHelperService } from '@frontend/vanilla/shared/forms';

import { ZipProperties } from '../models/models';

@Directive({
    selector: '[ptPostalCodeProperties]',
    standalone: true,
})
export class PostalCodePropertiesDirective {
    @Input() set ptPostalCodeProperties(value: ZipProperties) {
        this.setup(value);
    }

    @HostBinding('attr.maxlength') maxLength: number;
    @HostBinding('attr.type') type: string;

    constructor(private validationHelper: ValidationHelperService) {}

    private setup(props: ZipProperties) {
        const rules = Object.assign({}, this.validationHelper.getRules('addresszip'), props);

        const alphaNumeric = rules.regex.includes('a') || rules.regex.includes('-');

        this.type = alphaNumeric ? 'text' : 'tel';
        this.maxLength = rules.maxLength;
    }
}
